import CreationCellphonesPageWrapper from './Views/CreationCellphonesWrapper/CreationCellphonesPageWrapper'
import CreationCleaningActivitiesPageWrapper from './Views/CreationCleaningActivititesWrapper/CreationCleaningActivitiesPageWrapper'
import StartPageWrapper from './Views/StartWrapper/StartPageWrapper'
import TypeBuildingPageWrapper from './Views/TypeBuildingWrapper/TypeBuildingPageWrapper'
import AssignmentCellphonePageWrapper from './Views/AssignmentCellphoneWrapper/AssignmentCellphonePageWrapper'
import CleaningSchedulePageWrapper from './Views/CleaningScheduleWrapper/CleaningSchedulePageWrapper'
import AssignmentCleaningSchedulesPageWrapper from './Views/AssignmentCleaningSchedulesWrapper/AssignmentCleaningSchedulesPageWrapper'
import {ReportCensusHistoryPageWrapper} from './Views/CensusHistory/CensusHistoryPageWrapper'
import {CleaningStatusPageWrapper} from './Views/CleaningStatusWrapper/CleaningStatusPageWrapper'

export const ListWrappers = {
  'type-of-building': <TypeBuildingPageWrapper />,
  'creation-of-cleaning-activities': <CreationCleaningActivitiesPageWrapper />,
  'assignment-of-cellphones': <AssignmentCellphonePageWrapper />,
  'creation-of-cellphones': <CreationCellphonesPageWrapper />,
  'cleaning-schedule': <CleaningSchedulePageWrapper />,
  'assignment-of-cleaning-schedules': <AssignmentCleaningSchedulesPageWrapper />,
  'reports-census-history': <ReportCensusHistoryPageWrapper />,
  'reports-cleaning-status': <CleaningStatusPageWrapper />,
  start: <StartPageWrapper />,
} as any

export const renderPanelContent = (key: string | undefined) => {
  let component = <></>
  if (key) {
    component = ListWrappers[key]
  }
  return component
}
